import {
  LayoutDashboard,
  Receipt,
  Package,
  History,
  Truck,
  Users2,
  UserCog,
  BarChart3,
  Settings,
  ShieldCheck,
  CreditCard,
  ScrollText,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import { type PermissionKey, PERMISSIONS } from '@/auth/permissions';

export interface NavItem {
  to: string;
  label: string;
  /** i18n key with a faithful legacy translation. Falls back to `label` (English) when absent — most of today's nav items (Audit log, Subscription, Platform admin) postdate the legacy app and have no translation yet. */
  labelKey?: string;
  icon: LucideIcon;
  /** Undefined means "always visible once signed in" — e.g. Subscription. */
  permission?: PermissionKey;
  end?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'Dashboard', labelKey: 'navDashboard', icon: LayoutDashboard, end: true },
  { to: '/billing', label: 'Billing', labelKey: 'navBilling', icon: Receipt, permission: PERMISSIONS.salesCreate },
  { to: '/inventory', label: 'Inventory', labelKey: 'navMedicines', icon: Package, permission: PERMISSIONS.medicinesView },
  { to: '/sales', label: 'Sales history', labelKey: 'navSales', icon: History, permission: PERMISSIONS.salesView },
  { to: '/purchases', label: 'Purchase orders', labelKey: 'navPurchaseOrders', icon: Truck, permission: PERMISSIONS.purchasesView },
  { to: '/suppliers', label: 'Suppliers', labelKey: 'navSuppliers', icon: Truck, permission: PERMISSIONS.suppliersView },
  { to: '/customers', label: 'Customers', labelKey: 'navCustomers', icon: Users2, permission: PERMISSIONS.customersView },
  { to: '/reports', label: 'Reports', labelKey: 'navReports', icon: BarChart3, permission: PERMISSIONS.reportsSales },
  { to: '/users', label: 'Staff & permissions', labelKey: 'navUsers', icon: UserCog, permission: PERMISSIONS.usersView },
  { to: '/audit-log', label: 'Audit log', icon: ScrollText, permission: PERMISSIONS.auditView },
  // No permission gate: every signed-in user has a password to change,
  // even if they can't see store-wide settings.
  { to: '/settings', label: 'Settings', labelKey: 'navSettings', icon: Settings },
];

/** Always reachable — a lapsed pharmacy has to be able to renew. */
export const SUBSCRIPTION_NAV: NavItem = {
  to: '/subscription',
  label: 'Subscription',
  icon: CreditCard,
};

export const SUPERADMIN_NAV: NavItem = {
  to: '/superadmin',
  label: 'Platform admin',
  icon: ShieldCheck,
};
